import { render, staticRenderFns } from "./ManutencaoView.vue?vue&type=template&id=92072d28&scoped=true"
import script from "./ManutencaoView.vue?vue&type=script&lang=js"
export * from "./ManutencaoView.vue?vue&type=script&lang=js"
import style0 from "./ManutencaoView.vue?vue&type=style&index=0&id=92072d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92072d28",
  null
  
)

export default component.exports